import React from 'react'
import aboutImg1 from '../assets/images/about-img-1.jpg';
import contactUsImg from '../assets/images/contact-us-img.svg';
import iconFinancialStrategies from '../assets/images/icon-financial-strategies.svg';
import iconPhone from '../assets/images/icon-phone.svg';
import author1 from '../assets/images/author-1.jpg';
import author2 from '../assets/images/author-2.jpg';
import author3 from '../assets/images/author-3.jpg';
import iconService1 from '../assets/images/icon-service-1.svg';
import iconService2 from '../assets/images/icon-service-2.svg';
import iconService3 from '../assets/images/icon-service-3.svg';
import iconService4 from '../assets/images/icon-service-4.svg';
import iconService5 from '../assets/images/icon-service-5.svg';
import iconService6 from '../assets/images/icon-service-6.svg';
import arrowWhite from '../assets/images/arrow-white.svg';
import whyChooseImg1 from '../assets/images/why-choose-img-1.jpg';
import whyChooseImg2 from '../assets/images/why-choose-img-2.jpg';
import iconWhyChoose1 from '../assets/images/icon-why-choose-2.svg';
import iconWhyChoose2 from '../assets/images/icon-why-choose-2.svg';
import aboutImg2 from '../assets/images/about-img-2.jpg';


import iconPricingBenefit1 from '../assets/images/icon-pricing-benefit-1.svg';
import iconPricingBenefit2 from '../assets/images/icon-pricing-benefit-2.svg';


import mission from '../assets/images/icon-our-mission.svg';
import ourvision from '../assets/images/icon-our-vision.svg';
import ourvisionnn from '../assets/images/our-vision-img.jpg';
import ourvalueimg from '../assets/images/our-value-img.jpg';
import iconourfeature1 from '../assets/images/icon-our-feature-1.svg';
import iconourfeature2 from '../assets/images/icon-our-feature-2.svg';
import iconourfeature3 from '../assets/images/icon-our-feature-3.svg';
import iconourfeature4 from '../assets/images/icon-our-feature-4.svg';
import iconourfeature5 from '../assets/images/icon-our-feature-5.svg';
import iconourfeature6 from '../assets/images/icon-our-feature-6.svg';
import ourbenefit from '../assets/images/our-benefit-img.jpg';
import ourbenefit1 from '../assets/images/icon-our-benefit-1.svg';
import ourbenefit2 from '../assets/images/icon-our-benefit-2.svg';
import ourbenefit3 from '../assets/images/icon-our-benefit-3.svg';
import ourbenefit4 from '../assets/images/icon-our-benefit-4.svg';
import ourpartner1 from '../assets/images/our-partner-1.svg';
import ourpartner2 from '../assets/images/our-partner-2.svg';
import ourpartner3 from '../assets/images/our-partner-3.svg';
import ourpartner4 from '../assets/images/our-partner-4.svg';

import imagesteam1 from '../assets/images/team-1.jpg';
import imagesteam2 from '../assets/images/team-2.jpg';
import imagesteam13 from '../assets/images/team-3.jpg';
import customerlogo from '../assets/images/customer-logo.svg';
import testimonialquotes from '../assets/images/testimonial-quotes.svg';
import icongoogle from '../assets/images/icon-google.svg';
import customerratingimg from '../assets/images/customer-rating-img.svg';
import faqsimg from '../assets/images/faqs-img.jpg';
import faqsimsatisfyclientimg1 from '../assets/images/satisfy-client-img-1.jpg';
import faqsimsatisfyclientimg2 from '../assets/images/satisfy-client-img-2.jpg';
import faqsimsatisfyclientimg3 from '../assets/images/satisfy-client-img-3.jpg';
import faqsimsatisfyclientimg4 from '../assets/images/satisfy-client-img-4.jpg';
import faqsimsatisfyclientimg5 from '../assets/images/satisfy-client-img-5.jpg';
import iconourvalue from '../assets/images/icon-our-value.svg';
import whatwedoimg1 from '../assets/images/what-we-do-img-2.jpg';
import whatwedoimg2 from '../assets/images/what-we-do-img-2.jpg';
import whatwedoimg from '../assets/images/what-we-do-img-1.jpg';
import ourmissionimg from '../assets/images/our-mission-img.jpg';
import ourbenefit01 from '../assets/images/our-benefit-img.jpg';

// import conourvalue from '../assets/images/icon-our-value.svg"';



function About() {
  return (
    <>
      <div className="page-header">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              {/* Page Header Box Start */}
              <div className="page-header-box">
                <h1 className="text-anime-style-2" data-cursor="-opaque">
                  About us
                </h1>
                <nav className="wow fadeInUp">
                  {/* <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="./">home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  about us
                </li>
              </ol> */}
                </nav>
              </div>
              {/* Page Header Box End */}
            </div>
          </div>
        </div>
      </div>
      {/* Page Header End */}
      {/* About Us Section Start */}
      <div className="about-us">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              {/* About Us Images Start */}
              <div className="about-us-images">
                {/* About Image 1 Start */}
                <div className="about-img-1">
                  <figure className="image-anime reveal">
                    <img src={aboutImg1} alt="aboutImg1" />
                  </figure>
                </div>
                {/* About Image 1 End */}
                {/* About Image 2 Start */}
                <div className="about-img-2">
                  <figure className="image-anime reveal">
                    <img src={aboutImg2} alt="aboutImg2" />
                  </figure>
                </div>
                {/* About Image 2 End */}
                {/* Contact Circle Start */}
                <div className="contact-circle">
                  <img src={contactUsImg} alt="contactUsImg" />

                </div>
                {/* Contact Circle End */}
              </div>
              {/* About Us Images End */}
            </div>
            <div className="col-lg-6">
              {/* About Us Content Start */}
              <div className="about-us-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">about us</h3>
                  <h2 className="text-anime-style-2">
                    Trusted Help to Integrate Your <span>KYC & Security APIs</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    We connect you with leading KYC/AML providers. We help you choose the right verification solution, integrate seamlessly, and maintain compliance easily.
                  </p>
                </div>
                {/* Section Title End */}
                {/* About Content body Start */}
                <div className="about-content-body">
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      {/* About Content Info Start */}
                      <div className="about-content-info">
                        {/* About Goal Box Start */}
                        <div
                          className="about-goal-box wow fadeInUp"
                          data-wow-delay="0.4s"
                        >
                          <div className="icon-box">
                            <img
                              src={iconFinancialStrategies}
                              alt="iconFinancialStrategies"
                            />
                          </div>
                          <div className="about-goal-box-content">
                            <h3>security architecture</h3>
                            <p>
                              Tailored API integration plans to meet your unique compliance needs and protection goals.
                            </p>
                          </div>
                        </div>
                        {/* About Goal Box End */}
                        {/* About Contact Box Start */}
                        <div
                          className="about-contact-box wow fadeInUp"
                          data-wow-delay="0.6s"
                        >
                          <div className="icon-box">
                            <img src={iconPhone} alt="iconPhone" />
                          </div>
                          <div className="about-contact-content">
                            <p>
                              <a href="tel:91-7339983554">91-7339983554</a>
                            </p>
                          </div>
                        </div>
                        {/* About Contact Box End */}
                      </div>
                      {/* About Content Info End */}
                    </div>
                    <div className="col-md-6">
                      {/* About Author Box Start */}
                      <div
                        className="about-author-box wow fadeInUp"
                        data-wow-delay="0.4s"
                      >
                        {/* About Info Box Start */}
                        <div className="about-info-box">
                          <figure className="image-anime reveal">
                            <img src={author1} alt="author1" />
                          </figure>
                          <div className="about-author-content">
                            <h3>Sarah T.</h3>
                            <p>Co. founder</p>
                          </div>
                        </div>
                        {/* About Info Box End */}
                        {/* About Info List Start */}
                        <div className="about-info-list">
                          <ul>
                            <li>threat detection</li>
                            <li>incident response</li>
                            <li>24/7 monitoring</li>
                          </ul>
                        </div>
                        {/* About Info List End */}
                      </div>
                      {/* About Author Box End */}
                    </div>
                  </div>
                </div>
                {/* About Content body End */}
              </div>
              {/* About Us Content End */}
            </div>
          </div>
        </div>
      </div>
      {/* About Us Section End */}
      {/* Our Approach Section Start */}
      <div className="our-approach">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-6">
              {/* Section Title Start */}
              <div className="section-title">
                <h3 className="wow fadeInUp">our approach</h3>
                <h2 className="wow fadeInUp" data-wow-delay="0.2s">
                  Customized strategies for <span>compliance & security</span>
                </h2>
              </div>
              {/* Section Title End */}
            </div>
            <div className="col-lg-6">
              {/* Section Btn Start */}
              <div className="section-btn wow fadeInUp" data-wow-delay="0.2s">
                <a href="contact.html" className="btn-default">
                  Contact now
                </a>
              </div>
              {/* Section Btn Start */}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6">
              {/* Mission Vision Item Start */}
              <div className="mission-vission-item wow fadeInUp">
                {/* Mission Vision Header Start */}
                <div className="mission-vission-header">
                  <div className="icon-box">
                    <img src={mission} alt="mission" />
                  </div>
                  <div className="mission-vission-content">
                    <h3>our mission</h3>
                    <p>
                      To empower businesses with secure, compliant, and innovative KYC/AML solutions that simplify identity verification and fraud prevention.
                    </p>
                  </div>
                </div>
                {/* Mission Vision Header End */}
                {/* Mission Vision Image Start */}
                <div className="mission-vission-image">
                  <figure className="image-anime">
                    <img src={ourmissionimg} alt="ourmissionimg" />
                  </figure>
                </div>
                {/* Mission Vision Image End */}
              </div>
              {/* Mission Vision Item End */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Mission Vision Item Start */}
              <div
                className="mission-vission-item wow fadeInUp"
                data-wow-delay="0.2s"
              >
                {/* Mission Vision Header Start */}
                <div className="mission-vission-header">
                  <div className="icon-box">
                    <img src={ourvision} alt="ourvision" />
                  </div>
                  <div className="mission-vission-content">
                    <h3>our vision</h3>
                    <p>
                      To become a trusted global compliance partner, driving digital trust and regulatory excellence for businesses worldwide.
                    </p>
                  </div>
                </div>
                {/* Mission Vision Header End */}
                {/* Mission Vision Image Start */}
                <div className="mission-vission-image">
                  <figure className="image-anime">
                    <img src={ourvisionnn} alt="ourvisionnn" />
                  </figure>
                </div>
                {/* Mission Vision Image End */}
              </div>
              {/* Mission Vision Item End */}
            </div>
            <div className="col-lg-4 col-md-6">
              {/* Mission Vision Item Start */}
              <div
                className="mission-vission-item wow fadeInUp"
                data-wow-delay="0.4s"
              >
                {/* Mission Vision Header Start */}
                <div className="mission-vission-header">
                  <div className="icon-box">
                    <img src={iconourvalue} alt="iconourvalue" />
                  </div>
                  <div className="mission-vission-content">
                    <h3>our value</h3>
                    <p>
                      Innovation, Integrity, and Compliance guide everything we do — ensuring regulatory alignment, data protection, and long-term partnerships.
                    </p>
                  </div>
                </div>
                {/* Mission Vision Header End */}
                {/* Mission Vision Image Start */}
                <div className="mission-vission-image">
                  <figure className="image-anime">
                    <img src={ourvalueimg} alt="ourvalueimg" />
                  </figure>
                </div>
                {/* Mission Vision Image End */}
              </div>
              {/* Mission Vision Item End */}
            </div>
          </div>
        </div>
      </div>
      {/* Our Approach Section End */}
      {/* Why Choose Us Section Start */}
      <div className="why-choose-us">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* Why Choose Content Start */}
              <div className="why-choose-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">why choose us</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Why trust us <span>your compliance & security</span>
                  </h2>
                </div>
                {/* Section Title End */}
                {/* Why Choose Box List Start */}
                <div className="why-choose-box-list">
                  {/* Why Choose Box Start */}
                  <div
                    className="why-choose-box wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="icon-box">
                      <img src={iconWhyChoose1} alt="iconWhyChoose1" />
                    </div>
                    <div className="why-choose-box-content">
                      <h3>Regulatory Compliance Expertise</h3>
                      <p>
                        Our KYC and security solutions are built on robust compliance frameworks and regulatory expertise, ensuring your business can operate confidently without compromising on legal standards.
                      </p>
                    </div>
                  </div>
                  {/* Why Choose Box End */}
                  {/* Why Choose Box Start */}
                  <div
                    className="why-choose-box wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="icon-box">
                      <img src={iconWhyChoose1} alt="iconWhyChoose1" />
                    </div>
                    <div className="why-choose-box-content">
                      <h3>Customer-Centric Compliance</h3>
                      <p>
                        We design our verification services with your success in mind — providing seamless integration, 24/7 monitoring, and innovative tools that make compliance operations simple and efficient.
                      </p>
                    </div>
                  </div>
                  {/* Why Choose Box End */}
                </div>
                {/* Why Choose Box List End */}
                {/* Why Choose List Start */}
                <div className="why-choose-list wow fadeInUp" data-wow-delay="0.4s">
                  <ul>
                    <li>KYC/AML compliance frameworks</li>
                    <li>expert security advisory</li>
                  </ul>
                </div>
                {/* Why Choose List End */}
              </div>
              {/* Why Choose Content End */}
            </div>
            <div className="col-lg-6">
              {/* Why Choose Image Start */}
              <div className="why-choose-image">
                {/* Why Choose Image 1 Start */}
                <div className="why-choose-img-1">
                  <figure className="image-anime reveal">
                    <img src={whyChooseImg1} alt="whyChooseImg1" />
                  </figure>
                </div>
                {/* Why Choose Image 1 End */}
                {/* Why Choose Image 2 Start */}
                <div className="why-choose-img-2">
                  <figure className="image-anime reveal">
                    <img src={whyChooseImg2} alt="whyChooseImg2" />
                  </figure>
                </div>
                {/* Why Choose Image 2 End */}
                {/* Why Choose Contact Circle Start */}
                <div className="why-choose-contact-circle">
                  <img src={contactUsImg} alt="contactUsImg" />
                </div>
                {/* Why Choose Contact Circle Start */}
              </div>
              {/* Why Choose Image End */}
            </div>
          </div>
        </div>
      </div>
      {/* Why Choose Us Section End */}
      {/* Our Feature Section Stat */}
      <div className="our-feature">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-6">
              {/* Section Title Start */}
              <div className="section-title dark-section">
                <h3 className="wow fadeInUp">our feature</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Key features of our KYC <span>and security solutions</span>
                </h2>
              </div>
              {/* Section Title End */}
            </div>
            <div className="col-lg-6">
              {/* Section Button Start */}
              <div className="section-btn wow fadeInUp" data-wow-delay="0.2s">
                <a href="contact.html" className="btn-default">
                  contact now
                </a>
              </div>
              {/* Section Button End */}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              {/* Our Feature List Start */}
              <div className="our-feature-list">
                {/* Feature Item Start */}
                <div className="our-feature-item wow fadeInUp">
                  <div className="icon-box">
                    <img src={iconourfeature1} alt="iconourfeature1" />
                  </div>
                  <div className="feature-item-content">
                    <h3>Seamless API Integration</h3>
                    <p>
                      Easily connect our KYC/AML solutions with your existing systems for a hassle-free verification experience.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div
                  className="our-feature-item wow fadeInUp"
                  data-wow-delay="0.2s"
                >
                  <div className="icon-box">
                    <img src={iconourfeature2} alt="iconourfeature2" />
                  </div>
                  <div className="feature-item-content">
                    <h3>Advanced Security Standards</h3>
                    <p>
                      End-to-end encryption and real-time fraud detection ensure every identity verification is secure and compliant.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div
                  className="our-feature-item wow fadeInUp"
                  data-wow-delay="0.4s"
                >
                  <div className="icon-box">
                    <img src={iconourfeature3} alt="iconourfeature3" />
                  </div>
                  <div className="feature-item-content">
                    <h3>Real-Time Verification</h3>
                    <p>
                      Instant identity checks, document validation, and compliance updates keep your business running smoothly.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div
                  className="our-feature-item wow fadeInUp"
                  data-wow-delay="0.6s"
                >
                  <div className="icon-box">
                    <img src={iconourfeature4} alt="iconourfeature4" />
                  </div>
                  <div className="feature-item-content">
                    <h3>Customizable Workflows</h3>
                    <p>
                      Tailored KYC workflows to match your business model, risk profile, and compliance requirements.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div
                  className="our-feature-item wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <div className="icon-box">
                    <img src={iconourfeature5} alt="iconourfeature5" />
                  </div>
                  <div className="feature-item-content">
                    <h3>24/7 Compliance Monitoring</h3>
                    <p>
                      Dedicated technical and compliance support whenever you need assistance with verification issues.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
                {/* Feature Item Start */}
                <div className="our-feature-item wow fadeInUp" data-wow-delay="1s">
                  <div className="icon-box">
                    <img src={iconourfeature6} alt="iconourfeature6" />
                  </div>
                  <div className="feature-item-content">
                    <h3>Analytics & Audit Reports</h3>
                    <p>
                      Smart dashboards and compliance reports help you make data-driven security decisions.
                    </p>
                  </div>
                </div>
                {/* Feature Item End */}
              </div>
              {/* Our Feature List End */}
            </div>
            <div className="col-lg-12">
              {/* Our Featured Footer Start */}
              <div
                className="our-feature-footer wow fadeInUp"
                data-wow-delay="1.2s"
              >
                <p>
                  <span>Free</span> Let's make your compliance seamless together.{" "}
                  <a href="contact.html">Get Free Consultation</a>
                </p>
              </div>
              {/* Our Featured Footer End */}
            </div>
          </div>
        </div>
      </div>
      {/* Our Feature Section End */}
      {/* Our Benefit Section Start */}

      <div className="our-benefit">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* Our Benefit Content Start */}
              <div className="our-benefit-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">our benefits</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Maximizing trust with expert <span>compliance solutions</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Unlocking growth opportunities with tailored KYC/AML strategies for maximum security and long-term regulatory success.
                  </p>
                </div>
                {/* Section Title End */}
                {/* Our Benefit Button Start */}
                <div className="our-benefit-btn wow fadeInUp" data-wow-delay="0.4s">
                  <a href="contact.html" className="btn-default">
                    get started
                  </a>
                </div>
                {/* Our Benefit Button End */}
                <div className="our-benefit-img">
                  <figure className="image-anime reveal">
                    <img src={ourbenefit} alt="ourbenefit" />
                  </figure>
                </div>
              </div>
              {/* Our Benefit Content End */}
            </div>
            <div className="col-lg-6">
              {/* Our Benefit Box Start */}
              <div className="our-benefit-box">
                {/* Our Benefit List Start */}
                <div className="our-benefit-list">
                  {/* Our Benefit Item Start */}
                  <div className="our-benefit-item wow fadeInUp">
                    <div className="icon-box">
                      <img src={ourbenefit1} alt="ourbenefit1" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>compliance expertise</h3>
                      <p>
                        Benefit from our team's deep regulatory expertise, providing tailored KYC solutions and reliable support to help you meet compliance requirements.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                  {/* Our Benefit Item Start */}
                  <div
                    className="our-benefit-item wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <div className="icon-box">
                      <img src={ourbenefit2} alt="ourbenefit2" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>fraud prevention</h3>
                      <p>
                        Stay protected with advanced security frameworks, real-time fraud detection, and compliance-driven processes designed to minimize risks.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                  {/* Our Benefit Item Start */}
                  <div
                    className="our-benefit-item wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <div className="icon-box">
                      <img src={ourbenefit3} alt="ourbenefit3" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>scalable infrastructure</h3>
                      <p>
                        Our verification solutions are built to adapt as your business expands, ensuring sustainable compliance and security over time.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                  {/* Our Benefit Item Start */}
                  <div
                    className="our-benefit-item wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <div className="icon-box">
                      <img src={ourbenefit4} alt="ourbenefit4" />
                    </div>
                    <div className="benefit-item-content">
                      <h3>integration efficiency</h3>
                      <p>
                        Save valuable development time with automated verification processes, real-time identity checks, and easy API integrations.
                      </p>
                    </div>
                  </div>
                  {/* Our Benefit Item End */}
                </div>
                {/* Our Benefit List End */}
                {/* Our Benefit Get Quote Text Start */}
                <div
                  className="our-benefit-get-quote wow fadeInUp"
                  data-wow-delay="0.8s"
                >
                  <p>
                    {" "}
                    Let's make your compliance seamless together.{" "}
                    <a href="#">Get Free Consultation</a>
                  </p>
                </div>
                {/* Our Benefit Get Quote Text End */}
              </div>
              {/* Our Benefit Box End */}
            </div>
          </div>
        </div>
      </div>


      {/* Our Benefit Section End */}
      {/* What We Do Section Start */}
      <div className="what-we-do">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* What We Do Content Start */}
              <div className="what-we-do-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">what we do</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Driving compliance excellence <span>and security</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    We provide expert KYC and security consulting solutions designed to foster regulatory stability, trust, and long-term fraud prevention.
                  </p>
                </div>
                {/* Section Title End */}
                {/* What We Do List Start */}
                <div className="what-we-do-list wow fadeInUp" data-wow-delay="0.4s">
                  <ul>
                    <li>KYC/AML compliance setup</li>
                    <li>identity verification solutions</li>
                    <li>fraud detection &amp; risk mitigation</li>
                    <li>regulatory audit preparation</li>
                  </ul>
                </div>
                {/* What We Do List End */}
                {/* What We Do Button Start */}
                <div className="what-we-do-btn wow fadeInUp" data-wow-delay="0.6s">
                  <a href="contact.html" className="btn-default">
                    contact now
                  </a>
                </div>
                {/* What We Do Button End */}
              </div>
              {/* What We Do Content End */}
            </div>
            <div className="col-lg-6">
              {/* What We Do Images Start */}
              <div className="what-we-do-images">
                {/* What We Do Image 1 Start */}
                <div className="what-do-we-img-1">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg} alt="whatwedoimg" />
                  </figure>
                </div>
                {/* What We Do Image 1 End */}
                {/* What We Do Image 2 Start */}
                <div className="what-do-we-img-2">
                  <figure className="image-anime reveal">
                    <img src={whatwedoimg2} alt="whatwedoimg2" />
                  </figure>
                </div>
                {/* What We Do Image 2 End */}
                {/* Experience Counter Box Start */}
                <div className="experience-counter-box">
                  <div className="experience-counter-no">
                    <h2>
                      <span className="counter">5</span>+
                    </h2>
                  </div>
                  <div className="experience-counter-content">
                    <p>Years of experience in KYC & security</p>
                  </div>
                </div>
                {/* Experience Counter Box Start End */}
              </div>
              {/* What We Do Images End */}
            </div>
          </div>
        </div>
      </div>
      {/* What We Do Section End */}
      {/* How It Work Section Start */}
      <div className="how-it-work">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              {/* How It Work Content Start */}
              <div className="how-it-work-content">
                {/* Section Title Start */}
                <div className="section-title">
                  <h3 className="wow fadeInUp">how it work</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">
                    Our process for compliance <span>& security</span>
                  </h2>
                  <p className="wow fadeInUp" data-wow-delay="0.2s">
                    Our process is designed to guide you every step of the way. From initial compliance assessment to seamless API integration.
                  </p>
                </div>
                {/* Section Title End */}
                {/* How It Work Button Start */}
                <div className="how-it-work-btn wow fadeInUp" data-wow-delay="0.4s">
                  <a href="contact.html" className="btn-default">
                    learn more
                  </a>
                </div>
                {/* How It Work Button End */}
              </div>
              {/* How It Work Content End */}
            </div>
            <div className="col-lg-6">
              {/* Work Steps Box Start */}
              <div className="work-steps-box">
                {/* Work Steps Item Start */}
                <div className="work-step-item wow fadeInUp">
                  <div className="work-step-item-content">
                    <h3>step</h3>
                    <h2>Consult & Assess</h2>
                    <p>
                      Schedule a consultation to assess your compliance needs, risk profile, and verification requirements.
                    </p>
                  </div>
                  <div className="work-step-item-no">
                    <h2>01</h2>
                  </div>
                </div>
                {/* Work Steps Item End */}
                {/* Work Steps Item Start */}
                <div className="work-step-item wow fadeInUp" data-wow-delay="0.2s">
                  <div className="work-step-item-content">
                    <h3>step</h3>
                    <h2>Integrate & Configure</h2>
                    <p>
                      Connect our KYC/AML solutions with your systems, customized to match your compliance workflows.
                    </p>
                  </div>
                  <div className="work-step-item-no">
                    <h2>02</h2>
                  </div>
                </div>
                {/* Work Steps Item End */}
                {/* Work Steps Item Start */}
                <div className="work-step-item wow fadeInUp" data-wow-delay="0.4s">
                  <div className="work-step-item-content">
                    <h3>step</h3>
                    <h2>Verify & Comply</h2>
                    <p>
                      Start verifying identities, detecting fraud, and maintaining compliance with real-time monitoring.
                    </p>
                  </div>
                  <div className="work-step-item-no">
                    <h2>03</h2>
                  </div>
                </div>
                {/* Work Steps Item End */}
              </div>
              {/* Work Steps Box End */}
            </div>
          </div>
        </div>
      </div>
      {/* How It Work Section End */}
      {/* Our Partners Section Start */}

      {/* Our Partners Section End */}
      {/* Our Team Section Start */}

      {/* Our Team Section End */}
      {/* Our Testimonial Section Start */}

      {/* Our Testimonial Section End */}
      {/* Our FAQs Section Start*/}
      <div className="our-faqs">
        <div className="container">
          <div className="row section-row align-items-center">
            <div className="col-lg-6">
              {/* Section Title Start */}
              <div className="section-title">
                <h3 className="wow fadeInUp">faqs</h3>
                <h2 className="text-anime-style-2" data-cursor="-opaque">
                  Your most frequently asked <span>compliance questions answered</span>
                </h2>
              </div>
              {/* Section Title End */}
            </div>
            <div className="col-lg-6">
              {/* Section Button Start */}
              <div className="section-btn">
                <a href="faqs.html" className="btn-default">
                  view all FAQs
                </a>
              </div>
              {/* Section Button End */}
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              {/* Our FAQs Image Start */}
              <div className="our-faqs-image">
                {/* Our FAQs Img Start */}
                <div className="our-faqs-img">
                  <figure className="image-anime reveal">
                    <img src={faqsimg} alt="faqsimg" />
                  </figure>
                </div>
                {/* Our FAQs Img End */}
                {/* Client Review Box Start */}
                <div className="client-review-box">
                  {/* Client Review Box Content Start */}
                  <div className="client-review-box-content">
                    <p>
                      100+ Clients{" "}
                      <span>
                        <i className="fa-solid fa-star" /> 5.0 (250 Reviews)
                      </span>
                    </p>
                  </div>
                  {/* Client Review Box Content End */}
                  {/* Client Review Images Start */}
                  <div className="client-review-images">
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img src={faqsimsatisfyclientimg1} alt="faqsimsatisfyclientimg1" />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img src={faqsimsatisfyclientimg2} alt="faqsimsatisfyclientimg2" />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img src={faqsimsatisfyclientimg3} alt="faqsimsatisfyclientimg3" />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img src={faqsimsatisfyclientimg4} alt="faqsimsatisfyclientimg4" />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Client Image Start */}
                    <div className="client-image">
                      <figure className="image-anime">
                        <img src={faqsimsatisfyclientimg5} alt="faqsimsatisfyclientimg5" />
                      </figure>
                    </div>
                    {/* Client Image End */}
                    {/* Add More Client Image Start */}
                    <div className="client-image add-more">
                      <p>
                        <span className="counter">30</span>+
                      </p>
                    </div>
                    {/* Add More Client Image End */}
                  </div>
                  {/* Client Review Images End */}
                </div>
                {/* Client Review Box End */}
              </div>
              {/* Our FAQs Image End */}
            </div>
            <div className="col-lg-6">
              {/* Our FAQ Section Start */}
              <div className="our-faq-section">
                {/* FAQ Accordion Start */}
                <div className="faq-accordion" id="faqaccordion">
                  {/* Accordion Item Start */}
                  <div className="accordion-item wow fadeInUp">
                    <h2 className="accordion-header" id="heading1">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse1"
                        aria-expanded="true"
                        aria-controls="collapse1"
                      >
                        What KYC/AML services do you offer?
                      </button>
                    </h2>
                    <div
                      id="collapse1"
                      className="accordion-collapse collapse"
                      aria-labelledby="heading1"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          If you're uncertain about managing compliance requirements, implementing identity verification, or meeting regulatory standards, consulting a KYC/security professional can help. Our team assists in clarifying your compliance goals, optimizing your verification workflows, and ensuring regulatory alignment.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                  {/* Accordion Item Start */}
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-delay="0.2s"
                  >
                    <h2 className="accordion-header" id="heading2">
                      <button
                        className="accordion-button "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse2"
                        aria-expanded="false"
                        aria-controls="collapse2"
                      >
                        How do I know if I need a KYC compliance consultant?
                      </button>
                    </h2>
                    <div
                      id="collapse2"
                      className="accordion-collapse collapse show"
                      aria-labelledby="heading2"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          If you're uncertain about managing identity verification, meeting AML regulations, or implementing secure API integrations, consulting a compliance professional can help. Our team assists in clarifying your regulatory requirements, optimizing your security protocols, and ensuring long-term compliance.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                  {/* Accordion Item Start */}
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-delay="0.4s"
                  >
                    <h2 className="accordion-header" id="heading3">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse3"
                        aria-expanded="false"
                        aria-controls="collapse3"
                      >
                        What can I expect from an initial compliance consultation?
                      </button>
                    </h2>
                    <div
                      id="collapse3"
                      className="accordion-collapse collapse"
                      aria-labelledby="heading3"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          If you're uncertain about managing KYC workflows, selecting verification providers, or structuring your compliance systems, consulting a security professional can help. Our team assists in clarifying your verification goals, optimizing your integration strategy, and ensuring regulatory readiness.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                  {/* Accordion Item Start */}
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-delay="0.6s"
                  >
                    <h2 className="accordion-header" id="heading4">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse4"
                        aria-expanded="false"
                        aria-controls="collapse4"
                      >
                        Are my compliance consultations confidential?
                      </button>
                    </h2>
                    <div
                      id="collapse4"
                      className="accordion-collapse collapse"
                      aria-labelledby="heading4"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          Yes, all consultations are strictly confidential. We follow industry-grade data protection protocols to ensure your business information, compliance data, and security requirements remain private and protected at all times.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                  {/* Accordion Item Start */}
                  <div
                    className="accordion-item wow fadeInUp"
                    data-wow-delay="0.8s"
                  >
                    <h2 className="accordion-header" id="heading5">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapse5"
                        aria-expanded="false"
                        aria-controls="collapse5"
                      >
                        What kind of clients do you work with?
                      </button>
                    </h2>
                    <div
                      id="collapse5"
                      className="accordion-collapse collapse"
                      aria-labelledby="heading5"
                      data-bs-parent="#faqaccordion"
                    >
                      <div className="accordion-body">
                        <p>
                          We work with fintech startups, e-commerce platforms, financial institutions, and any business requiring KYC/AML compliance solutions. From small businesses to large enterprises, we tailor our verification services to match your specific industry needs and regulatory requirements.
                        </p>
                      </div>
                    </div>
                  </div>
                  {/* Accordion Item End */}
                </div>
                {/* FAQ Accordion End */}
              </div>
              {/* Our FAQ Section End */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default About